import React, { useEffect, useState, useRef, useMemo } from "react";
import { Link } from "react-router-dom";
import withRouter from "components/Common/withRouter";
import TableContainer from "../../../components/Common/TableContainer";
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  Label,
  FormFeedback,
  UncontrolledTooltip,
  Input,
  Form,
} from "reactstrap";
import * as Yup from "yup";
import { useFormik } from "formik";
import { NameSurname } from "./contactlistCol";


//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb";
import DeleteModal from "components/Common/DeleteModal";
import axios from 'axios';

import "jspdf-autotable";

import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import Dropzone from 'react-dropzone-uploader';
import { Base64 } from 'js-base64';
import toastr from 'toastr'; // toastr kütüphanesini içe aktarın
import 'toastr/build/toastr.min.css'; // toastr stillerini içe aktarın


import {
  getRest as onGetRest,
  addRest as onAddRest,
  updateRest as onUpdateRest,
  deleteRest as onDeleteRest,
} from "store/contacts/actions";
import { isEmpty } from "lodash";

//redux
import { useSelector, useDispatch } from "react-redux";
import moment from "moment";
import CreditModal from "components/Common/CreditModal";

const ContactsList = props => {
  const tableRef = useRef(null);

  //meta title
  document.title = "Rest. Hakediş | Tazelya ADMIN PANELI";

  const dispatch = useDispatch();
  const [contact, setContact] = useState();
  const [contactEdit, setEditContact] = useState();

  const [getHtmlDataLong, setHtmlDataLong] = useState();
   const [getHtmlDataLongTwo, setHtmlDataLongTwo] = useState();
   const [getHtmlDataLongThird, setHtmlDataLongThird] = useState();


  const [orders, setOrder] = useState([]);
  const [creditModal, setCreditModal] = useState(false);

  
  // validation

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      title: (contactEdit && contactEdit.Title) || "",
      titleeng: (contactEdit && contactEdit.TitleEng) || "",
      titlethird: (contactEdit && contactEdit.TitleThird) || "",
  
    
    },
    validationSchema: Yup.object({
      title: Yup.string(3).required("Başlığı Giriniz"),


    }),
    onSubmit: values => {
      if (isEdit) {

        const updateUser = {
          ID: contactEdit.ID,
          Title: values.title,
          TitleEng: values.titleeng,
          TitleThird: values.titlethird,
          ConsultancyDesc: Base64.encode(getHtmlDataLong),
          ConsultancyDescEng:Base64.encode(getHtmlDataLongTwo),
          ConsultancyDescThird:Base64.encode(getHtmlDataLongThird),
          ConsultancyImage: values.blogimage,
        

        };
        dispatch(onUpdateCons(updateUser));
        setIsEdit(false);
        validation.resetForm();
      } else {
        const newUser = {
          Title: values["title"],
          TitleEng:values["titleeng"],
          TitleThird:values["titlethird"],
          ConsultancyDesc: Base64.encode(getHtmlDataLong),
          ConsultancyDescEng:Base64.encode(getHtmlDataLongTwo),
          ConsultancyDescThird:Base64.encode(getHtmlDataLongThird),

          ConsultancyImage: values["blogimage"],
     

        };
        // save new user
        dispatch(onAddRest(newUser));
        validation.resetForm();
      }
      toggle();
    },
  });

  const { users } = useSelector(state => ({
    users: state.contacts.rest,
  }));

  const [modal, setModal] = useState(false);
  const [modalMedia, setModalMedia] = useState(false);

  const [isEdit, setIsEdit] = useState(false);




  const columns = useMemo(
    () => [
      {
        Header: "#",
        Cell: () => {
          return <input type="checkbox" className="form-check-input" />;
        },
      },

      {
        Header: "Rest. Adı",
        accessor: "ResName",
        filterable: true,
        Cell: cellProps => {
          return <NameSurname {...cellProps} />;
        },
      },

      {
        Header: "İşlemler",
        Cell: cellProps => {
          return (
            <div className="d-flex gap-3">

             
              <Link
                to="#"
                className="text-success"
                onClick={() => {
                  const userData = cellProps.row.original;
                  handleUserClickMedia(userData);
                }}
              >
                <i className="mdi mdi-eye font-size-18" id="edittooltip" />
                <UncontrolledTooltip placement="top" target="edittooltip">
                  Siparişleri Görüntüle
                </UncontrolledTooltip>
              </Link>
             
            </div>
          );
        },
      },
    ],
    []
  );


  useEffect(() => {
    if (users && !users.length) {
        dispatch(onGetRest(null));
      setIsEdit(false);
    }
  }, [dispatch, users]);

  useEffect(() => {
    setContact(users);
    // setIsEdit(false);
  }, [users]);

  useEffect(() => {
    if (!isEmpty(users) && !!isEdit) {
      setContact(users);
      //setIsEdit(false);
    }
  }, [users]);

  const toggle = () => {
    setModal(!modal);
  };

  const toggleMedia = () => {
    setModalMedia(!modalMedia);
  };
  const [userList, setUserList] = useState([]);

  const handleUserClickMedia = async(arg) => {
    const user = arg;
   
    await axios.get(`https://tazelyadmin.stechomeyazilim.info:5556/getOrderRestSearch/select/${user.ID}`)
    .then((res) => {
     
    console.log("user1231",res.data)
    setOrder(res.data)

    })

    toggleMedia();
  };

  const [groupedOrders, setGroupedOrders] = useState({});
  const [transferLog, setTransferLog] = useState([]);

  useEffect(() => {
    // Siparişleri Complated_Order_ID'ye göre grupla
    const groupByOrderId = orders.reduce((acc, order) => {
      const { Complated_Order_ID, Complated_Order } = order;
      if (!acc[Complated_Order_ID]) {
        acc[Complated_Order_ID] = {
          ...Complated_Order,
          items: [],
        };
      }
      acc[Complated_Order_ID].items.push(order);
      return acc;
    }, {});

    setGroupedOrders(groupByOrderId);
  }, [orders]);

  // transfer_log tablosundaki amount toplamı
  const totalAmountPaid = transferLog.reduce((sum, log) => sum + log.amount, 0);

  // Complated_Order tablosundaki toplam fiyat
  const totalHakEdis = Object.values(groupedOrders).reduce(
    (sum, order) => sum + order.TotalPrice,
    0
  );

  // Yapılan ödeme (Hakedişten transfer edilen amount'ları çıkar)
  const remainingPayment = totalHakEdis - totalAmountPaid;

  const showToast= async (type,message) => {
    let ele = null
   
  
     if(type == true){
       ele = "success"
       message = message
    } else{
       ele = "error"
       message = message
    };
    const position = ["toast-top-right"];
    let toastType;
    const title = "Başlık";
  
  
    //Close Button
    const closeButton = true;
  
    //Debug
    const debug = false;
  
    //Progressbar
    const progressBar = true;
  
    //Duplicates
    const preventDuplicates = false;
  
    //Newest on Top
    const newestOnTop = true;
  
    //position class
    let positionClass = "toast-top-right";
  
    //Show Easing
    const showEasing = "swing";
  
    //Hide Easing
    const hideEasing = "linear";
  
    //show method
    const showMethod = "fadeIn";
  
    //Hide method
    const hideMethod = "fadeOut";
  
    //show duration
    const showDuration = 300;
  
    //Hide duration
    const hideDuration = 1000;
  
    //timeout
    const timeOut = 5000;
  
    //extended timeout
    const extendedTimeOut = 1000;
  
    //Fetch checked Type
   
     toastType = ele;
    
  
    toastr.options = {
      positionClass: positionClass,
      timeOut: timeOut,
      extendedTimeOut: extendedTimeOut,
      closeButton: closeButton,
      debug: debug,
      progressBar: progressBar,
      preventDuplicates: preventDuplicates,
      newestOnTop: newestOnTop,
      showEasing: showEasing,
      hideEasing: hideEasing,
      showMethod: showMethod,
      hideMethod: hideMethod,
      showDuration: showDuration,
      hideDuration: hideDuration
    };
  
    // setTimeout(() => toastr.success(`Settings updated `), 300)
    //Toaster Types
    if (toastType === "info") toastr.info(message, title);
    else if (toastType === "warning") toastr.warning(message, title);
    else if (toastType === "error") toastr.error(message, title);
    else toastr.success(message, title);
  }


  const handlePayment = (order) => {

    console.log("şlmsdflş",order)
    // Eğer bu sipariş için zaten transfer_log kaydı varsa ödeme yapma
    const existingLog = transferLog.find(log => log.Complated_Order_ID === order.ID);
    if (existingLog) return;

   
   {/**  const newTransferLog = {
      id: transferLog.length + 1,
      trans_id: `TRX-${Math.floor(Math.random() * 10000)}`,
      amount: order.TotalPrice * (order.Rest_Commission / 100), // Komisyon hesaplanıyor
      Users_ID: order.Users.ID,
      Rest_BankHolderName: order.Rest_BankHolderName || "Bilinmiyor",
      Rest_Iban: order.Rest_Iban || "Bilinmiyor",
      Complated_Order_OID: order.Complated_Order_OID || null,
      Complated_Order_ID: order.ID,
    };

   
    setTransferLog([...transferLog, newTransferLog]);

    alert(`Sipariş ID: ${order.ID} için ödeme yapıldı!`);

*/}

    const notification = {
      Complated_Order_ID : parseInt(order.ID),
      Rest_Commission: order.items[0].Rest_Product.Rest.Rest_Commission,
      created_at: new Date().toISOString(),
      total_amount : parseFloat(order.items[0].Complated_Order.TotalPrice),
      restID : parseInt(order.items[0].Rest_Product.Rest_ID),
      Complated_Order_OID : order.items[0].Complated_Order.Complated_Order_OID,
    }
    
    setCreditModal(false)
    axios.post('https://tazelyadmin.stechomeyazilim.info:5556/addTransferStechome/send', notification)
    .then(response => {
      console.log("Başarılı Yanıt:", response.data); // Sunucudan gelen yanıtı burada yakalarsınız
      showToast(true, "B1aşarıyla Ödeme Talebi Oluşturdunuz!");

      toggleMedia()
    })
    .catch(error => {
      console.error("Hata Oluştu:", error.response ? error.response.data : error.message);
      showToast(false, "Ödeme Talebi Oluşturulurken Hata Oluştu!");
    });

  };

  // Tüm siparişler için ödeme yap
  
  const handleAllPayments = () => {
    console.log("şsdmflsdşf",Object.values(groupedOrders))
    
    const newTransferLogs = Object.values(groupedOrders).map(item =>  {
        const notification = {
        Complated_Order_ID : parseInt(item.ID),
        Rest_Commission: item.items[0].Rest_Product.Rest.Rest_Commission,
        created_at: new Date().toISOString(),
        total_amount : parseFloat(item.items[0].Complated_Order.TotalPrice),
        restID : parseInt(item.items[0].Rest_Product.Rest_ID),
        Complated_Order_OID : item.items[0].Complated_Order.Complated_Order_OID,
      }
      
      setCreditModal(false)
      axios.post('https://tazelyadmin.stechomeyazilim.info:5556/addTransferStechome/send', notification)
      .then(response => {
        console.log("Başarılı Yanıt:", response.data); // Sunucudan gelen yanıtı burada yakalarsınız
        showToast(true, "B1aşarıyla Ödeme Talebi Oluşturdunuz!");
  
        toggleMedia()
      })
      .catch(error => {
        console.error("Hata Oluştu:", error.response ? error.response.data : error.message);
        showToast(false, "Ödeme Talebi Oluşturulurken Hata Oluştu!");
      })}
    );

   // setTransferLog([...transferLog, ...newTransferLogs]);

   toggleMedia()
    //("Tüm siparişler için ödeme yapıldı!");
  };



  var node = useRef();
  const onPaginationPageChange = page => {
    if (
      node &&
      node.current &&
      node.current.props &&
      node.current.props.pagination &&
      node.current.props.pagination.options
    ) {
      node.current.props.pagination.options.onPageChange(page);
    }
  };

  //delete customer
  const [deleteModal, setDeleteModal] = useState(false);

  const onClickDelete = users => {
    setContact(users);
    setDeleteModal(true);
  };

  const handleDeleteUser = () => {
    if (contact && contact.ID) {
      dispatch(onDeleteCons(contact.ID));
    }
    onPaginationPageChange(1);
    setDeleteModal(false);
  };

  const handleUserClicks = () => {
    setUserList("");
    setIsEdit(false);
    toggle();
  };

  const _setChoiceCategory = arg => {
    setCategoryID(arg.target.value)
  }

  const Preview = ({ meta }) => {
    const { name, percent, status, previewUrl } = meta;
    return (
      <div className="preview-box">
        <img src={previewUrl} /> <span className="name">{name}</span> - <span className="status">{status == "done" ? "Başarıyla Yüklendi" : "Yükleniyor"}</span>{status !== "done" && <span className="percent"> ({Math.round(percent)}%)</span>}
      </div>
    )
  }


  const getUploadParams = ({ file }) => {
    const body = new FormData();
    body.append('dataFile', file);

    return { url: 'https://megaadmin.stechomeyazilim.info:8080/uploadfile', body }
  }

  const handleChangeStatus = ({ xhr }) => {
    if (xhr) {
      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4) {
          const result = JSON.parse(xhr.response);
          setFileName(result.file.filename)

        }
      }
    }
  }
  return (
    <React.Fragment>
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteUser}
        onCloseClick={() => setDeleteModal(false)}
      />

      

      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Breadcrumbs title="Yönetim" breadcrumbItem="Restorant Hakediş Listesi" />

          <Row>
            <Col lg="12">
              <Card>
                <CardBody>


                  <TableContainer
                    columns={columns}
                    data={users}
                    ref={tableRef}
                    isGlobalFilter={true}
                    isAddCons={false}
                    handleOrderClicks={handleUserClicks}
                    customPageSize={10}
                    className="custom-header-css"
                  />

                  <Modal isOpen={modalMedia} toggle={toggleMedia}>
                    <ModalHeader toggle={toggleMedia} tag="h4">
                      {!!isEdit ? "Düzenle" : "Siparişler"}
                    </ModalHeader>
                    <ModalBody>

            
                      <Row>

                      <div>
      <h2>Sipariş Listesi</h2>
      {Object.values(groupedOrders).map((order, index) => {
        // Bu siparişe ait yapılan ödeme tutarı
        const orderPaidAmount = transferLog
          .filter(log => log.Complated_Order_ID === order.ID)
          .reduce((sum, log) => sum + log.amount, 0);

        // Bu sipariş için kalan ödeme
        const orderRemainingPayment = order.TotalPrice - orderPaidAmount;

        console.log("şlmdşlf123",order)
        return (
          <div key={index} style={{ border: "1px solid black", marginBottom: "10px", padding: "10px" }}>
            <h3>Sipariş ID: {order.ID}</h3>
            <p><strong>Toplam Fiyat:</strong> {order.TotalPrice} TL</p>
            <p><strong>Order:</strong> {order.Complated_Order_OID}</p>
            <p><strong>Sipariş Durumu:</strong> {order.Order_Status.Order_Status_Title}</p>
            <p><strong>Hakediş:</strong> {order.TotalPrice} TL</p>
            <p><strong>Yapılan Ödeme:</strong> {orderPaidAmount.toFixed(2)} TL</p>
            <p><strong>Kalan Ödeme:</strong> {orderRemainingPayment.toFixed(2)} TL</p>

            <h4>Ürünler:</h4>
            <ul>
              {order.items.map((item) => (
                <li key={item.ID}>
                  {item.Rest_Product.Products.Products_Name} - {item.Quantity} adet
                </li>
              ))}
            </ul>

            {order.transfer_log?.length > 0 ? (
              <div style={{ background: "#eee", padding: "10px", marginTop: "10px" }}>
                <h4>Transfer Log Detayları:</h4>
                <pre>{JSON.stringify(order.transfer_log, null, 2)}</pre>
              </div>
            ) : (
              <p style={{ color: "red" }}>Transfer Log Bulunmuyor.</p>
            )}
           
            {/* Eğer sipariş için transfer_log kaydı yoksa ödeme butonunu göster */}
            {order.transfer_log?.length == 0 ? (
              <button
                onClick={() => handlePayment(order)}
                style={{
                  padding: "10px",
                  backgroundColor: "green",
                  color: "white",
                  border: "none",
                  cursor: "pointer",
                  marginTop: "10px",
                }}
              >
                Bu Sipariş İçin Ödeme Yap
              </button>
            ) : null}
          </div>
        );
      })}

      {/* Genel Ödeme Bilgileri */}
      <h3>Toplam Ödeme Bilgileri</h3>
      <p><strong>Hakediş Toplamı:</strong> {totalHakEdis.toFixed(2)} TL</p>
      <p><strong>Yapılan Ödeme:</strong> {totalAmountPaid.toFixed(2)} TL</p>
      <p><strong>Kalan Ödeme:</strong> {remainingPayment.toFixed(2)} TL</p>
      <p><strong>Toplam Hakediş Tutarı:</strong> {totalAmountPaid.toFixed(2)} TL</p>

      {/* Eğer tüm siparişler zaten ödendiyse buton gösterilmesin */}
      {Object.values(groupedOrders).some(order => !transferLog.find(log => log.Complated_Order_ID === order.ID)) && (
        <button
          onClick={handleAllPayments}
          style={{
            padding: "10px",
            backgroundColor: "blue",
            color: "white",
            border: "none",
            cursor: "pointer",
            marginTop: "10px",
          }}
        >
          Tüm Ödemeleri Yap
        </button>
      )}
    </div>

                        <Col>
                          <div className="text-end">
                            <button
                            onClick={()=> toggleMedia()}
                              type="submit"
                              className="btn btn-success save-user"
                            >
                            Kapat
                            </button>
                          </div>
                        </Col>
                      </Row>

                    </ModalBody>
                  </Modal>

                  <Modal isOpen={modal} toggle={toggle}>
                    <ModalHeader toggle={toggle} tag="h4">
                      {!!isEdit ? "Düzenle" : "Danışmanlık Ekle"}
                    </ModalHeader>
                    <ModalBody>
                      <Form
                        onSubmit={e => {
                          e.preventDefault();
                          validation.handleSubmit();
                          return false;
                        }}
                      >
                        <Row>
                          <Col xs={12}>



                            <div className="mb-3">
                              <Label className="form-label">Danışmanlık Başlık</Label>
                              <Input
                                name="title"
                                label="title"
                                type="text"
                                placeholder="Danışmanlık Başlık Giriniz"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.title || ""}
                                invalid={
                                  validation.touched.title &&
                                    validation.errors.title
                                    ? true
                                    : false
                                }
                              />
                              {validation.touched.title &&
                                validation.errors.title ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.title}
                                </FormFeedback>
                              ) : null}
                            </div>



                            <div className="mb-3">
                              <Label className="form-label">Uzun Açıklama</Label>

                              <Form method="post">
                                <CKEditor
                                  editor={ClassicEditor}
                                  data={getHtmlDataLong}
                                  onReady={editor => {
                                    // You can store the "editor" and use when it is needed.
                                    console.log('Editor is ready to use!', editor);
                                  }}
                                  onChange={(event, editor) => {
                                    const data = editor.getData();
                                    setHtmlDataLong(data)

                                  }}
                                />
                              </Form>
                            </div>

                          



                            <div className="mb-3">
                              <Label className="form-label">Danışmanlık Başlık Eng</Label>
                              <Input
                                name="titleeng"
                                label="titleeng"
                                type="text"
                                placeholder="Eng Danışmanlık Başlık Giriniz"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.titleeng || ""}
                                invalid={
                                  validation.touched.titleeng &&
                                    validation.errors.titleeng
                                    ? true
                                    : false
                                }
                              />
                              {validation.touched.titleeng &&
                                validation.errors.titleeng ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.titleeng}
                                </FormFeedback>
                              ) : null}
                            </div>



                            <div className="mb-3">
                              <Label className="form-label">Uzun Açıklama Eng</Label>

                              <Form method="post">
                                <CKEditor
                                  editor={ClassicEditor}
                                  data={getHtmlDataLongTwo}
                                  onReady={editor => {
                                    // You can store the "editor" and use when it is needed.
                                    console.log('Editor is ready to use!', editor);
                                  }}
                                  onChange={(event, editor) => {
                                    const data = editor.getData();
                                    setHtmlDataLongTwo(data)

                                  }}
                                />
                              </Form>
                            </div>




                            <div className="mb-3">
                              <Label className="form-label">Danışmanlık Başlık Third</Label>
                              <Input
                                name="titlethird"
                                label="titlethird"
                                type="text"
                                placeholder="Third Danışmanlık Başlık Giriniz"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.titlethird || ""}
                                invalid={
                                  validation.touched.titlethird &&
                                    validation.errors.titlethird
                                    ? true
                                    : false
                                }
                              />
                              {validation.touched.titlethird &&
                                validation.errors.titlethird ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.titlethird}
                                </FormFeedback>
                              ) : null}
                            </div>



                            <div className="mb-3">
                              <Label className="form-label">Uzun Açıklama Third</Label>

                              <Form method="post">
                                <CKEditor
                                  editor={ClassicEditor}
                                  data={getHtmlDataLongThird}
                                  onReady={editor => {
                                    // You can store the "editor" and use when it is needed.
                                    console.log('Editor is ready to use!', editor);
                                  }}
                                  onChange={(event, editor) => {
                                    const data = editor.getData();
                                    setHtmlDataLongThird(data)

                                  }}
                                />
                              </Form>
                            </div>

                            <div className="mb-3">
                              <Col xs={12} className="mb-3">
                                <label htmlFor="resume">Görsel</label>
                                <Dropzone
                                  getUploadParams={getUploadParams}
                                  onChangeStatus={handleChangeStatus}
                                  styles={{
                                    dropzone: { overflow: 'auto', border: '1px solid #999', background: '#f5f5f5' },
                                    inputLabelWithFiles: { margin: '20px 3%' }
                                  }}

                                  canRemove={false}
                                  PreviewComponent={Preview}
                                  accept="image/*"
                                />

                              </Col>
                            </div>


                          
                          </Col>
                        </Row>
                        <Row>



                          <Col>
                            <div className="text-end">
                              <button
                                type="submit"
                                className="btn btn-success save-user"
                              >
                                Kaydet
                              </button>
                            </div>
                          </Col>
                        </Row>
                      </Form>
                    </ModalBody>
                  </Modal>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withRouter(ContactsList);
